import session from '@updater-core/interactors/shell/session';
import { fetchGraphQLQuery } from '@updater-core/lib/graphql';
import { ENVIRONMENT } from '@updater-core/lib/environment';

export async function getVariation(experiment) {
  const sessionState = session.getState();
  const headers = session.selectors.requestHeaders(sessionState);

  const response = await fetchGraphQLQuery({
    url: `${ENVIRONMENT.endpoints.api.url}/graphql`,
    query: `
      query getExperimentVariation($experiment: String!){
        getExperimentVariation(experiment: $experiment) {
          variationKey,
          logs
        }
      }
    `,
    variables: {
      experiment,
    },
    headers,
  });

  return response?.data?.getExperimentVariation?.variationKey;
}
